import { CanDeactivateFn, GuardResult, MaybeAsync } from '@angular/router';

/**
 * Used as a return type of the 'canDeactivate' function.
 */
export type CanDeactivateType = MaybeAsync<GuardResult>;
/**
 * Interface used in components to implement can deactivate.
 */
export interface CanDeactivateComponent {
    /**
     * Can deactivate handler function.
     * Determines if the current user is allowed to deactivate the component.
     * @returns Can deactivate result.
     */
    canDeactivate: () => CanDeactivateType;
}

/**
 * Guard determines if the current user is allowed to deactivate the component.
 * @param component Can deactivate component.
 * @returns Can deactivate result.
 */
export const CanDeactivateGuard: CanDeactivateFn<CanDeactivateComponent> = (
    component: CanDeactivateComponent
) => {
    return component.canDeactivate ? component.canDeactivate() : true;
};
